<template>
  <div id="main">
    <div class="title-wrap">
      <div class="title-name">账号设置</div>
    </div>
    <div class="form-wrap">
      <div class="from-item" v-for="(item, index) in itemArr" :key="index">
        <div class="form-content">
          <span class="label">{{ item.label }}</span>
          <div class="input" :class="{ wide: index == 2 || index == 3 }">
            {{ item.content | regroupPass }}
          </div>
        </div>
        <!--已认证开发者-->
        <template v-if="isDeveloper">
          <span
            class="btn"
            v-if="index == 1 || index == 3"
            @click="toPage(index, item.content)"
            >{{ getBtnTxt(item, index) }}</span
          >
        </template>
        <!--未认证开发者-->
        <template v-else>
          <span
            class="btn"
            v-if="index == 1"
            @click="toPage(index, item.content)"
            >{{ getBtnText(item, index) }}</span
          >
        </template>
      </div>
    </div>
    <el-dialog
      :visible.sync="addPhoneBle"
      class="add-dialog"
      width="600px"
      title="新增手机号"
    >
      <div class="dialog-content">
        <div class="send-box">
          <div class="title">手机号</div>
          <el-input type="input" v-model="phoneNumber"></el-input>
        </div>
        <div class="send-wrap">
          <div class="title">验证码</div>
          <el-input type="input" v-model="authCode"></el-input>
          <el-button
            type="warning"
            @click="getPhone"
            :class="{ 'btn-forbid': isDisabled }"
            >{{ codeTxt }}</el-button
          >
        </div>
        <div class="bottom-wrap">
          <el-button @click="confirm" type="warning">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getVercode, getKfzInfo } from '@/api/common';
import { changePhone } from '@/api/account';
export default {
  data() {
    return {
      isDeveloper: false,
      addPhoneBle: false,
      itemArr: [],
      isDisabled: false,
      codeTxt: '获取验证码',
      phoneNumber: '',
      authCode: '',
      btnTxt: '',
    };
  },
  mounted() {
    this.init();
    this.Report('view', 'AccountSettingsPage');
  },
  filters: {
    regroupPass(val) {
      let res = '';
      if (val) {
        res = val;
      } else {
        res = '未绑定';
      }
      return res;
    },
  },
  computed: {
    ...mapState(['developerInfo', 'bankInfo', 'userInfo']),
  },
  methods: {
    getPhone() {
      if (!this.phoneNumber) {
        this.$message.error('手机号不能为空');
      } else {
        this.fetchGetVercode();
      }
    },
    confirm() {
      this.addPhone();
    },
    async addPhone() {
      await changePhone({
        vercode: this.authCode,
        new_phone: this.phoneNumber,
        tk: this.userInfo.tk,
        op: 1,
      });
      this.$message.success('绑定成功');
      this.fetchKfzInfo();
      this.addPhoneBle = false;
    },
    init() {
      if (this.developerInfo.state == 0 || this.developerInfo.state == 3) {
        this.isDeveloper = false;
      } else {
        this.isDeveloper = true;
      }
      this.itemArr = [
        {
          label: '姓名',
          content: this.developerInfo.name,
        },
        {
          label: '电话',
          content: this.developerInfo.phone,
          operation: '',
        },
        {
          label: '身份证',
          content: this.developerInfo.id_card,
        },
        {
          label: '银行卡',
          content: this.bankInfo.bank_card,
          operation: '',
        },
      ];
    },
    getBtnTxt(item, index) {
      let txt = '';
      if ((index == 1 && item.content) || (index == 3 && item.content)) {
        txt = '修改';
      } else if (index == 1) {
        txt = '绑定手机号';
      } else {
        txt = '';
      }
      return txt;
    }, //getBtnText
    getBtnText(item, index) {
      let txt = '';
      if (index == 1 && item.content) {
        txt = '修改';
      } else {
        txt = '绑定手机号';
      }
      return txt;
    },
    toPage(index, content) {
      if (index == 1 && content) {
        this.$router.push({ name: 'accModifyPhone', params: { type: 'old' } });
      } else if (index == 1) {
        this.addPhoneBle = true;
      } else {
        /*  暂时屏蔽新增手机号功能
    else if(index==1){
        this.$router.push({name: 'accModifyPhone', params: { type: 'new' } });
      }    */
        this.$router.push({ name: 'settlementSet' });
      }
    },
    async fetchGetVercode() {
      try {
        await getVercode({ phone: this.phoneNumber, op: 1 });
        this.$message.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    countDown() {
      let time = 60;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.isDisabled = true;
          this.codeTxt = `重新发送${time}S`;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '获取验证码';
        }
      }, 1000);
    },
    async fetchKfzInfo() {
      try {
        const res = await getKfzInfo();
        this.$store.commit('SET_DEVELOPER_INFO', res.data);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#main {
  ::v-deep.el-dialog__header {
    padding: 0;
    padding-top: 40px;
    text-align: center;
    .el-dialog__title {
      font-size: 20px;
    }
  }
  .dialog-content {
    // display: flex;
    //flex-direction: column;
    .send-box {
      display: flex;
      margin-bottom: 40px;
      margin-left: 30px;
      font-size: 16px;
      .title {
        //margin-right: 20px;
        width: 110px;
        padding-top: 10px;
      }
      ::v-deep.el-input__inner {
        width: 360px !important;
      }
    }
    .send-wrap {
      margin-bottom: 20px;
      display: flex;
      margin-left: 30px;
      font-size: 16px;
      .title {
        width: 90px;
        padding-top: 10px;
      }
      ::v-deep.el-input {
        width: 240px;
      }
      ::v-deep.el-input__inner {
        width: 220px !important;
      }
      .el-button {
        height: 40px;
        border-radius: 8px;
        width: 120px;
      }
      .el-button.el-button--warning.btn-forbid {
        cursor: not-allowed;
        background: #d9d9d9 !important;
        border: none;
        &:hover {
          filter: brightness(100%);
        }
      }
    }
    .bottom-wrap {
      text-align: center;
      margin-top: 50px;
      margin-bottom: 20px;
      .el-button {
        width: 120px;
      }
    }
  }
  .title-wrap {
    font-size: 24px;
    color: #595959;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    margin-bottom: 24px;
  }
  .form-wrap {
    width: 61%;
    margin-left: 130px;
    margin-top: 36px;

    .from-item {
      display: flex;
      align-items: center;
      margin-bottom: 22px;
      justify-content: space-between;

      .form-content {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #606266;
        .input {
          height: 40px;
          width: 270px;
          border: 1px solid #e4e7ed;
          background-color: #f5f7fa;
          border-radius: 4px;
          color: #c0c4cc;
          line-height: 40px;
          text-indent: 20px;
        }
        .input.wide {
          width: 360px;
        }
      }

      .label {
        text-align: right;
        margin-right: 20px;
        width: 80px;
      }
    }
    .btn {
      color: #50a3f1;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        filter: brightness(105%);
      }
    }
  }
}
</style>
